<template>
  <div class="updatePws">
    <div class="title">
      修改密码
      <p></p>
    </div>

    <div class="form_div">
      <el-form class="addPage_form" :rules="rules" :model="form" ref="addPageForm">
        <el-form-item label="旧密码：" label-width="96px" prop="oldPws">
          <el-input type="password" v-model="form.oldPws" placeholder="请输入旧密码"></el-input>
        </el-form-item>

        <el-form-item label="密码：" label-width="96px" prop="newPws">
          <el-input type="password" v-model="form.newPws" placeholder="设置6至16位字母+数字登录密码"></el-input>
        </el-form-item>

        <el-form-item label="确认密码：" label-width="96px" prop="confirmPws">
          <el-input type="password" v-model="form.confirmPws" placeholder="请再次输入登录密码"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-button @click="updatePws">完成</el-button>
  </div>
</template>
<script>
export default {
  data() {
    //密码校验规则
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(value)) {
        callback(new Error("密码安全系数太低！"));
      }
      callback();
    };
    //确认密码校验规则
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.newPws) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      form: {
        oldPws: "",
        newPws: "",
        confirmPws: "",
      },
      rules: {
        oldPws: [{ required: true, message: "请填写旧密码", trigger: "blur" }],
        newPws: [
          {
            required: true,
            trigger: "blur",
            validator: validatePass,
          },
        ],
        confirmPws: [
          {
            required: true,
            trigger: "blur",
            validator: validatePass2,
          },
        ],
      },
    };
  },
  mounted() {
    let gzToken = this.$cookie.get("gzToken");
    if (!gzToken) {
      this.$message.error("登录失效，请重新登录");
      this.$router.push("/audLogin");
    }
  },
  methods: {
    updatePws() {
      this.$refs["addPageForm"].validate((valid) => {
        if (valid) {
          this.$http({
            url: "viewer/updatePwd",
            method: "post",
            params: {
              oldPwd: this.form.oldPws,
              newPwd: this.form.newPws,
            },
          }).then(({ data }) => {
            let { code } = data;
            if (code === 0) {
              this.$message.success("密码修改成功！");
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.updatePws {
  .el-input__inner {
    border-radius: 4px;
    height: 42px;
  }
}
</style>
<style lang="scss" scoped>
.updatePws {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 10px;
    p {
      width: 70px;
      height: 2px;
      background-color: #143372;
      position: absolute;
      bottom: -1px;
      left: 30px;
    }
  }
  .form_div {
    width: 720px;
    margin: 60px auto 0;
  }
  .el-button {
    width: 160px;
    height: 50px;
    background-color: #143372;
    color: #ffffff;
    font-size: 14px;
    margin: 300px 0 83px 379px;
  }
}
</style>